<form [formGroup]="form" (ngSubmit)="accept()" novalidate>
    <div class="modal-header">
        <h4 class="modal-title">Detalle Votación</h4>
        <button type="button" class="close" aria-label="Close" (click)="dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="row">

            <div class="form-group col-md-12">
                <label for="tituloVotacion">Titulo</label>
                <input type="tituloVotacion" class="form-control" id="tituloVotacion" formControlName="tituloVotacion"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.tituloVotacion.errors }">
                <div *ngIf="submitted && form.controls.tituloVotacion.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.tituloVotacion.errors.required">Campo requerido</div>
                </div>
            </div>

            <div class="form-group col-md-6">
                <label for="fechaInicio">Fecha de Inicio</label>
                <input type="date" class="form-control" id="fechaInicio" formControlName="fechaInicio"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.fechaInicio.errors }">
                <div *ngIf="submitted && form.controls.fechaInicio.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.fechaInicio.errors.required">Campo requerido</div>
                </div>
            </div>

            <div class="form-group col-md-6">
                <label for="horaInicio">Hora de Inicio</label>
                <input type="time" class="form-control" id="horaInicio" formControlName="horaInicio"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.horaInicio.errors }">
                <div *ngIf="submitted && form.controls.horaInicio.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.horaInicio.errors.required">Campo requerido</div>
                </div>
            </div>

            <div class="form-group col-md-6">
                <label for="fechaFin">Fecha de Término</label>
                <input type="date" class="form-control" id="fechaFin" formControlName="fechaFin"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.fechaFin.errors }">
                <div *ngIf="submitted && form.controls.fechaFin.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.fechaFin.errors.required">Campo requerido</div>
                </div>
            </div>

            <div class="form-group col-md-6">
                <label for="horaFin">Hora de Término</label>
                <input type="time" class="form-control" id="horaFin" formControlName="horaFin"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.horaFin.errors }">
                <div *ngIf="submitted && form.controls.horaFin.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.horaFin.errors.required">Campo requerido</div>
                </div>
            </div>

            <div class="form-group col-md-12">
                <label for="descripcion">Descripción</label>
                <textarea rows="5" class="form-control" id="descripcion" formControlName="descripcion"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.descripcion.errors }">
                </textarea>
                <div *ngIf="submitted && form.controls.descripcion.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.descripcion.errors.required">Campo requerido</div>
                </div>
            </div>

            <div class="form-group col-md-12">
                <label for="llavePublica">Llave Pública</label>
                <textarea #llavePublica rows="5" class="form-control" id="llavePublica" formControlName="llavePublica"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.llavePublica.errors }">
                </textarea>
                <div *ngIf="submitted && form.controls.llavePublica.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.llavePublica.errors.required">Campo requerido</div>
                </div>
            </div>
        </div>

        <div class="modal-footer full-width col-md-12">
            <div class="col-md-12 text-center">
                <button type="button" class="btn btn-danger btn-fidelis col-md-4" (click)="dismiss()">
                    <i class="fa fa-times-circle"></i>
                    Cancelar
                </button>
                <button type="submit" class="btn btn-success btn-fidelis col-md-4">
                    <i class="fa fa-check-circle"></i>
                    Aceptar
                </button>
            </div>
        </div>

    </div>
</form>